module.exports = __webpack_public_path__ + "855d6bd56f350c1f59d4af1b94e270ae.jpg";